import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d3c453d8&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c453d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3c453d8')) {
      api.createRecord('d3c453d8', component.options)
    } else {
      api.reload('d3c453d8', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d3c453d8&scoped=true&", function () {
      api.rerender('d3c453d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vitfXyMghxn7/JS/comp/SearchFilterTokens.vue"
export default component.exports